import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { StingrayAuthenticationService } from '@app/core/authentication/stingray-authentication.service';
import { I18nService } from '@app/core/i18n.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';

import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'unite-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [MatButton, TranslateModule, MatMenuTrigger, MatMenu, MatMenuItem, MatIcon]
})
export class LoginComponent {
  error: string;
  loginForm: UntypedFormGroup;
  isLoading = false;

  constructor(
    private title: Title,
    private translateService: TranslateService,
    private i18nService: I18nService,
    private stingrayAuthenticationService: StingrayAuthenticationService) {
    this.title.setTitle('Unite - ' + this.translateService.instant('Login'));
  }

  get currentLanguage(): string {
    return this.i18nService.language;
  }

  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  login(): void {
    this.isLoading = true;
    this.stingrayAuthenticationService.login();
  }

  setLanguage(language: string): void {
    this.i18nService.language = language;
  }
}
